// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { approveBomTemplateBinding } from "./schema/bill-of-materials/approve-bom-template-binding";
import { listBomTemplateBindings } from "./schema/bill-of-materials/list-bom-template-bindings";
import { listBomTemplates } from "./schema/bill-of-materials/list-bom-templates";
import { pauseBomTemplateBinding } from "./schema/bill-of-materials/pause-bom-template-binding";
import { previewBomTemplateBinding } from "./schema/bill-of-materials/preview-bom-template-binding";
import { rejectBomTemplateBinding } from "./schema/bill-of-materials/reject-bom-template-binding";
import { rejectBomTemplateFlows } from "./schema/bill-of-materials/reject-bom-template-flows";
import { setBomTemplateYield } from "./schema/bill-of-materials/set-bom-template-yield";
import { updateBomTemplateBinding } from "./schema/bill-of-materials/update-bom-template-binding";
import { getProductsForShopifyVariants } from "./schema/get-products-for-shopify-variants";
import { updateVariantListingImages } from "./schema/listing-images/update-variant-listing-images";
import { disableListing } from "./schema/listing-management/disable-listing";
import { enableListing } from "./schema/listing-management/enable-listing";
import {
  getSalesChannelInventory,
  importSalesChannelInventory,
  setSalesChannelInventoryPush,
  watchSalesChannelInventoryImports,
} from "./schema/settings/sales-channel-inventory";

export const groupG = {
  updateVariantListingImages,
  disableListing,
  enableListing,
  getProductsForShopifyVariants,
  listBomTemplates,
  listBomTemplateBindings,
  previewBomTemplateBinding,
  approveBomTemplateBinding,
  rejectBomTemplateBinding,
  rejectBomTemplateFlows,
  pauseBomTemplateBinding,
  updateBomTemplateBinding,
  setBomTemplateYield,
  getSalesChannelInventory,
  importSalesChannelInventory,
  setSalesChannelInventoryPush,
  watchSalesChannelInventoryImports,
};
